<div
  class="sport-country-avatars"
  [ngClass]="{ 'responsive-map-list': isResponsiveMapList }"
>
  <div class="circle-container left">
    <div class="circle">
      <span class="sport">
        <span class="icon icon-{{ sportName }}-new"></span>
      </span>
    </div>
  </div>
  <div class="circle-container right">
    <div class="circle">
      <img
        class="flag"
        [src]="'./assets/images/flags/allFlags/' + countryCode + '.svg'"
        [alt]="countryCode"
      />
    </div>
  </div>
</div>
